import { render, staticRenderFns } from "./NewsTemplate.vue?vue&type=template&id=fc9bb228&scoped=true"
import script from "./NewsTemplate.vue?vue&type=script&lang=js"
export * from "./NewsTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewsTemplate.vue?vue&type=style&index=0&id=fc9bb228&prod&scoped=true&lang=less"
import style1 from "./NewsTemplate.vue?vue&type=style&index=1&id=fc9bb228&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9bb228",
  null
  
)

export default component.exports